module.exports = require("core-js/modules/es.typed-array.index-of.js");